// src/lib/auth.ts
import { supabase } from "@/lib/supabase";

let cachedRole: "client" | "partner" | null = null;
let cacheTime = 0;

export async function getUserRole(): Promise<"client" | "partner" | null> {
  if (cachedRole && Date.now() - cacheTime < 5 * 60 * 1000) {
    return cachedRole;
  }

  const { data: { user } } = await supabase.auth.getUser();
  if (!user) {
    cachedRole = null;
    return null;
  }

  try {
    // Check partner first — use .single() so we know if row exists
    const { data: partner, error: partnerError } = await supabase
      .from("partner_accounts")
      .select("id")
      .eq("user_id", user.id)
      .single();

    if (partner && !partnerError) {
      cachedRole = "partner";
      cacheTime = Date.now();
      return "partner";
    }
  } catch (err) {
    // No partner row → expected, continue
    console.log("No partner account found for user:", user.id);
  }

  try {
    const { data: client, error: clientError } = await supabase
      .from("clients")
      .select("id")
      .eq("user_id", user.id)
      .single();

    if (client && !clientError) {
      cachedRole = "client";
      cacheTime = Date.now();
      return "client";
    }
  } catch (err) {
    console.log("No client account found for user:", user.id);
  }

  cachedRole = null;
  return null;
}

export function clearRoleCache() {
  cachedRole = null;
  cacheTime = 0;
}
